// extracted by mini-css-extract-plugin
module.exports = {"label":"RowPaginator_label__2dJrF","select":"RowPaginator_select__3qWZg"};